/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat Audience Segmentation — nested rule builder, segment list + metrics, viewer. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  /* Answers "is the deployed file the new one?" without a deploy archaeology session. If the
     console does not say 1.0.1, a stale edge copy is being served — purge the CDN. */
  try { (window.GS_BUILD = window.GS_BUILD || {})["audience-segmentation"] = "1.0.3"; } catch (e) {}
  function ic(n){ return (window.GSIcons&&GSIcons.svg)?(GSIcons.svg(n,16)+" "):""; }
  var root;
  function q(n){ return root?root.querySelector('[data-d="'+n+'"]'):null; }
  function qa(s,ctx){ return Array.prototype.slice.call((ctx||root).querySelectorAll(s)); }
  function esc(s){ return String(s==null?"":s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c];}); }
  function val(el){ return el?el.value.trim():""; }
  function ready(fn){ var d=false; function go(){ if(d)return; d=true; fn(); }
    document.addEventListener("gs:ready",go,{once:true});
    var n=0,t=setInterval(function(){ if(window.GS&&GS.api&&GS.site){clearInterval(t);go();} else if(++n>200)clearInterval(t); },30);
    if(window.GS&&GS.api&&GS.site)go(); }

  var LIST=[];
  function loadList(){ GS.api("/plugin/audience-segmentation/list?site="+encodeURIComponent(GS.site)).then(function(r){ LIST=(r.ok&&r.data&&r.data.segments)||[]; renderList(); }); }
  function renderList(){
    var tb=q("tbody");
    function segRow(g){
      return '<tr data-row="'+g.id+'"><td class="sn"><span class="s-dot" style="background:'+esc(g.color||"#1FA463")+'"></span>'+esc(g.name)+"</td>"+
        '<td class="r m-size">&middot;</td><td class="r m-sess">&middot;</td><td class="r m-eng">&middot;</td><td class="r m-conv">&middot;</td><td class="r m-ret">&middot;</td>'+
        '<td><span class="s-status '+(g.status==="active"?"on":"off")+'">'+esc(g.status)+'</span></td>'+
        '<td class="r nowrap"><button class="s-mini" data-edit="'+g.id+'"><i class="bi bi-pencil"></i></button> <button class="s-mini danger" data-del="'+g.id+'"><i class="bi bi-trash"></i></button></td></tr>';
    }
    function segHydrate(items){
      items.forEach(function(g){
        var tr = tb.querySelector('tr[data-row="'+g.id+'"]'); if(!tr) return;
        GS.api("/plugin/audience-segmentation/stats?site="+encodeURIComponent(GS.site)+"&segment="+g.id+"&from="+RANGE.from+"&to="+RANGE.to).then(function(r){
          if(!r.ok||!r.data)return; var d=r.data;
          tr.querySelector(".m-size").textContent=(d.size||0).toLocaleString();
          tr.querySelector(".m-sess").textContent=(d.sessions||0).toLocaleString();
          tr.querySelector(".m-eng").textContent=(d.engagement||0);
          tr.querySelector(".m-conv").textContent=(d.conversion_rate||0)+"%";
          tr.querySelector(".m-ret").textContent=(d.retention_rate||0)+"%";
        });
      });
    }
    if (window.GSMore) GSMore.mount({ container:tb, table:true, colspan:8, items:LIST, pageSize:20, emptyText:TR('audien.f3.no_segments_yet_click_u201cnew_seg'), render:segRow, onPage:segHydrate });
    else { tb.innerHTML = LIST.length ? LIST.map(segRow).join("") : '<tr><td colspan="8" class="empty">'+TR('audien.f2.no_segments_yet')+'</td></tr>'; segHydrate(LIST); }
    // One delegated listener covers rows and their edit/delete buttons, including rows
    // revealed later by "Load more" (per-element binding only ever reached the first page).
    if(!tb._segDelegated){ tb._segDelegated=1;
      tb.addEventListener("click",function(e){
        var ed=e.target.closest&&e.target.closest("[data-edit]"); if(ed){ editSeg(+ed.getAttribute("data-edit")); return; }
        var dl=e.target.closest&&e.target.closest("[data-del]");  if(dl){ delSeg(+dl.getAttribute("data-del")); return; }
        var tr=e.target.closest&&e.target.closest("tr[data-row]"); if(tr) openViewer(+tr.getAttribute("data-row"));
      });
    }
  }

  function openViewer(id){
    if (window.GSLink) window.GSLink.write({ id: id });   // the open view becomes linkable
    GS.api("/plugin/audience-segmentation/stats?site="+encodeURIComponent(GS.site)+"&segment="+id+"&from="+RANGE.from+"&to="+RANGE.to).then(function(r){
      if(!r.ok||!r.data||!r.data.available)return; var d=r.data; var v=q("viewer"); v.hidden=false; q("builder").hidden=true;
      q("viewer-title").textContent=(d.segment&&d.segment.name)||"Segment";
      q("k-size").textContent=(d.size||0).toLocaleString(); q("k-sess").textContent=(d.sessions||0).toLocaleString();
      q("k-eng").textContent=(d.engagement||0); q("k-conv").textContent=(d.conversion_rate||0)+"%"; q("k-ret").textContent=(d.retention_rate||0)+"%";
      var rw=q("k-rev-wrap"); if(d.revenue>0){ rw.hidden=false; q("k-rev").textContent=(d.revenue||0).toLocaleString(undefined,{minimumFractionDigits:2}); } else rw.hidden=true;
      var tl=d.timeline||[], mx=1; tl.forEach(function(x){ if(x.sessions>mx)mx=x.sessions; });
      q("timeline").innerHTML= tl.length ? tl.map(function(x){ return '<div class="s-tlcol" title="'+esc(x.date)+": "+x.sessions+'"><i style="height:'+Math.max(3,(x.sessions/mx*100))+'%"></i></div>'; }).join("") : '<div class="empty">'+TR('audien.g.no_sessions_in_this_range')+'</div>';
      var lp=q("launchpad");
      if(lp){
        var LP=[["retention","bi-arrow-repeat",TR('audien.g.retention_curves'),true],["visitor-lifetime","bi-hourglass-split",TR('audien.g.visitor_lifetime'),true],["cohort-analysis","bi-grid-3x3",TR('audien.g.cohort_analysis'),true],["behavioral-cohorts","bi-people-fill",TR('audien.g.behavioural_cohorts'),true]];
        lp.hidden=false;
        lp.innerHTML='<div class="seg-lp-h">'+TT('aud.js_seg_retains')+'<b>'+(d.retention_rate||0)+'%</b> \u2014 dig into retention &amp; lifetime</div>'+
          '<div class="seg-lp-links">'+LP.map(function(t){
            var href="/"+t[0]+(t[3]?("?segment="+encodeURIComponent(id)):"");
            return '<a class="seg-lp-a" href="'+href+'"'+(t[3]?' title="'+TT('aud.v.tip_scoped')+'"':'')+'><i class="bi '+t[1]+'"></i><span>'+esc(t[2])+'</span>'+(t[3]?'<span class="seg-lp-scoped">scoped</span>':'')+'</a>';
          }).join("")+'</div>';
      }
      v.scrollIntoView({behavior:"smooth",block:"nearest"});
    });
  }

  /* builder */
  function bf(k){ return root.querySelector('[data-bf="'+k+'"]'); }
  function addRule(groupEl, data){
    data=data||{rule_type:"page",value:""};
    var t=document.getElementById("seg-rule-tpl").content.firstElementChild.cloneNode(true);
    t.querySelector('[data-rf="rule_type"]').value=data.rule_type||"page";
    t.querySelector('[data-rf="value"]').value=data.value||"";
    t.querySelector("[data-rdel]").addEventListener("click",function(){ t.remove(); });
    groupEl.querySelector("[data-grules]").appendChild(t);
  }
  function addGroup(data){
    data=data||{match:"all",rules:[{rule_type:"page",value:""}]};
    var g=document.getElementById("seg-group-tpl").content.firstElementChild.cloneNode(true);
    g.querySelector("[data-gm]").value=data.match||"all";
    g.querySelector("[data-gdel]").addEventListener("click",function(){ g.remove(); relabelGroups(); });
    g.querySelector("[data-addrule]").addEventListener("click",function(){ addRule(g,null); });
    q("groups").appendChild(g);
    (data.rules&&data.rules.length?data.rules:[{rule_type:"page",value:""}]).forEach(function(r){ addRule(g,r); });
    relabelGroups();
  }
  function relabelGroups(){
    var mt=bf("match_type").value==="any"?"OR":"AND";
    qa("[data-group]").forEach(function(g,i){ g.querySelector(".s-gtag").textContent = i===0?"Group 1":(mt+" Group "+(i+1)); });
  }
  function openBuilder(seg){
    q("builder").hidden=false; q("viewer").hidden=true;
    q("builder-title").textContent=seg?("Edit \u2014 "+seg.name):TR('audien.g.new_segment');
    q("preview").hidden=true;
    bf("id").value=seg?seg.id:"";
    bf("name").value=seg?(seg.name||""):""; bf("description").value=seg?(seg.description||""):"";
    bf("color").value=seg?(seg.color||"#1FA463"):"#1FA463";
    bf("match_type").value=seg?(seg.match_type||"all"):"all"; bf("status").value=seg?(seg.status||"active"):"active";
    q("groups").innerHTML="";
    var groups=(seg&&seg.groups&&seg.groups.length)?seg.groups:[{match:"all",rules:[{rule_type:"page",value:""}]}];
    groups.forEach(addGroup);
    q("builder").scrollIntoView({behavior:"smooth",block:"start"});
  }
  function collect(){
    var groups=qa("[data-group]").map(function(g){
      return { match:g.querySelector("[data-gm]").value,
        rules:qa("[data-rule]",g).map(function(r){ return { rule_type:r.querySelector('[data-rf="rule_type"]').value, value:val(r.querySelector('[data-rf="value"]')) }; })
          .filter(function(r){ return r.value!==""||r.rule_type==="returning"; }) };
    }).filter(function(g){ return g.rules.length; });
    return { id:bf("id").value?+bf("id").value:0, name:val(bf("name")), description:val(bf("description")), color:bf("color").value,
      match_type:bf("match_type").value, status:bf("status").value, groups:groups };
  }
  function preview(){
    var p=collect(); var pv=q("preview"), txt=q("preview-txt"); pv.hidden=false; txt.textContent=TT('aud.a.calculating_u2026');
    GS.api("/plugin/audience-segmentation/preview?site="+encodeURIComponent(GS.site)+"&from="+RANGE.from+"&to="+RANGE.to,{method:"POST",body:JSON.stringify(p)}).then(function(r){
      if(r.ok&&r.data)txt.textContent=(r.data.size||0).toLocaleString()+" visitors \u00b7 "+(r.data.sessions||0).toLocaleString()+" sessions match";
      else txt.textContent=TT('aud.a.could_not_preview');
    });
  }
  function saveBuilder(){
    var p=collect(); if(!p.name){ q("builder-status").textContent=TT('aud.a.name_required'); return; }
    var st=q("builder-status"); st.textContent=TT('aud.a.saving_u2026');
    GS.api("/plugin/audience-segmentation/"+(p.id?"update":"create")+"?site="+encodeURIComponent(GS.site),{method:"POST",body:JSON.stringify(p)}).then(function(r){
      if(r.ok&&r.data&&(r.data.ok||r.data.id)){ st.textContent=TT('aud.a.saved_u2713'); q("builder").hidden=true; loadList(); } else st.textContent=TT('aud.a.error');
    });
  }
  function editSeg(id){ GS.api("/plugin/audience-segmentation/get?site="+encodeURIComponent(GS.site)+"&id="+id).then(function(r){ if(r.ok&&r.data&&r.data.id)openBuilder(r.data); }); }
  function delSeg(id){ var g=LIST.filter(function(e){return e.id===id;})[0]; if(!confirm(TT('aud.x.delete_segment')+' '+(g?('"'+g.name+'"'):"#"+id)+"?"))return;
    GS.api("/plugin/audience-segmentation/delete?site="+encodeURIComponent(GS.site),{method:"POST",body:JSON.stringify({id:id})}).then(function(){ q("viewer").hidden=true; loadList(); }); }

  function _ymd(d){ return d.getUTCFullYear()+"-"+("0"+(d.getUTCMonth()+1)).slice(-2)+"-"+("0"+d.getUTCDate()).slice(-2); }
  function _today(){ var t=new Date(); return new Date(Date.UTC(t.getFullYear(),t.getMonth(),t.getDate())); }
  function T(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function preset(days){ var to=_today(),from=new Date(to.getTime()-(days-1)*86400000); var lbl={7:T("an.last7"),30:T("an.last30"),90:T("an.last90")}[days]||T("an.lastndays",{n:days}); return {from:_ymd(from),to:_ymd(to),label:lbl,preset:String(days)}; }
  var RANGE=(function(){ try{ var s=JSON.parse(localStorage.getItem("gs_seg_range")||"null"); /* A stored preset is a RULE ("last 30 days"), not a fixed window. Restoring its
     absolute from/to means "last 30 days" quietly becomes "the 30 days ending whenever
     you last touched the picker" — today falls outside the range, the page looks stale,
     and Refresh re-queries the same dead window forever. Re-anchor presets to today;
     a CUSTOM range is genuinely absolute and is kept as stored. */
  if (s && s.preset) return preset(+s.preset);
  if(s&&s.from)return s; }catch(e){} return preset(30); })();
  function initRange(){
    var btn=q("rangeBtn"),menu=q("rangeMenu"),lab=q("range-label"); if(!btn)return;
    if(lab&&RANGE.label)lab.textContent=RANGE.label;
    btn.addEventListener("click",function(e){ if(menu.contains(e.target)&&e.target!==btn)return; e.stopPropagation(); menu.style.display=menu.style.display==="none"?"block":"none"; });
    document.addEventListener("click",function(){ menu.style.display="none"; });
    menu.addEventListener("click",function(e){ e.stopPropagation(); });
    menu.querySelectorAll(".rm[data-preset]").forEach(function(b){ b.addEventListener("click",function(){ RANGE=preset(+b.getAttribute("data-preset")); if(lab)lab.textContent=RANGE.label; try{localStorage.setItem("gs_seg_range",JSON.stringify(RANGE));}catch(e){} menu.style.display="none"; loadList(); }); });
    var _ap=menu.querySelector('[data-rp="apply"]');if(_ap)_ap.addEventListener("click",function(){var ff=(menu.querySelector('[data-rp="from"]')||{}).value,tt=(menu.querySelector('[data-rp="to"]')||{}).value;if(!ff||!tt)return;if(ff>tt){var x=ff;ff=tt;tt=x;}RANGE={from:ff,to:tt,label:ff+" \u2192 "+tt,preset:null};if(lab)lab.textContent=RANGE.label;try{localStorage.setItem("gs_audience-segmentation_range",JSON.stringify(RANGE));}catch(e){}menu.style.display="none";loadList();});
    btn.addEventListener("click",function(){var cf=menu.querySelector('[data-rp="from"]'),ct=menu.querySelector('[data-rp="to"]');if(cf&&RANGE.from)cf.value=RANGE.from;if(ct&&RANGE.to)ct.value=RANGE.to;});
  }
  function init(){
    root=document.querySelector('[data-d="root"]'); if(!root)return;
    q("new-seg").addEventListener("click",function(){ openBuilder(null); });
    q("add-group").addEventListener("click",function(){ addGroup(null); });
    q("builder-save").addEventListener("click",saveBuilder);
    q("builder-preview").addEventListener("click",preview);
    q("builder-cancel").addEventListener("click",function(){ q("builder").hidden=true; });
    q("builder-close").addEventListener("click",function(){ q("builder").hidden=true; });
    bf("match_type").addEventListener("change",relabelGroups);
    initRange(); loadList();
  }
  /* Deep link: /audience-segmentation?id=<v> opens that view directly, so it can be linked from an email,
     a dashboard widget or another report. The spelling lives in GSLink so no two pages can
     disagree about it. The inline fallback covers the window before gs-deeplink.js is deployed —
     it must ASSIGN, not return: an early return exits gsDeep() and the opener never fires.
     Anything malformed is ignored and the normal list loads. */
  function gsDeep() {
    var v = null;
    if (window.GSLink) {
      v = window.GSLink.read({ id: "int" }).id;
    } else {
      try {
        var p = new URLSearchParams(location.search);
        var _n = parseInt(String(p.get("id") || "").replace(/[^0-9-]/g, ""), 10);
        v = isNaN(_n) ? null : _n;
      } catch (e) { v = null; }
    }
    if (v !== null && v !== "") openViewer(v);
  }
  ready(function () { init(); gsDeep(); });
})();
